// extracted by mini-css-extract-plugin
module.exports = {"youTubeIcon":"webinar-content_youTubeIcon__2BYNw"};